import { publicAssetUrl } from '@chegg-wt/core/utils/url'
import styled from 'styled-components'

export const CheckboxContainer = styled.div`
  > input[type='checkbox'] {
    margin: 3px;
    border: 1px solid transparent;
    opacity: 0;
    position: absolute;
    cursor: pointer;
    & + label {
      margin: 0;
      cursor: pointer;
    }
    & + label:before {
      content: '';
      display: inline-block;
      width: 19px;
      height: 19px;
      margin-top: -2px;
      margin-right: ${(props) => props.theme.spacing.sm};
      vertical-align: middle;
      cursor: pointer;
      border-radius: ${(props) => props.theme.borderRadius};
      background-color: ${(props) => props.theme.colors.white};
      border: 2px solid ${(props) => props.theme.Colors.forInterface.interfaceColor15};
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
    }
    &:checked + label:before {
      background-image: ${`url(${publicAssetUrl('primary-checkmark.svg')});`};
    }
  }

  > input[type='checkbox']:focus {
    outline: none;
  }

  > input[type='checkbox']:focus-within {
    & + label:before {
      border: 2px solid #0090ff;
    }
  }
`
